<template>

        <div class="col-sm-6 col-lg-3" v-for="(item,index) in menudata" :key="index">
            <div class="card o-hidden">
                <div class="card-body">
                    <div class="d-flex static-widget">
                        <div class="flex-grow-1">
                            <h6 class="font-roboto">{{item.title}}</h6>
                            <h2 class="mb-0 counter"><number
                                class="bold "
                                ref="number1"
                                :from="0"
                                :to="item.counter"
                                :duration="5"
                                :delay="0"
                                easing="Power1.easeOut"
                              /></h2>
                        </div>
                      <component :is="item.svg"></component>
                  
                    </div>
                   
                    <div class="progress-widget">
                        <div class="progress sm-progress-bar progress-animate">
                            <div :class=item.class role="progressbar" :style="{'width':item.progress}" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"><span class="animate-circle"></span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
   
</template>

<script>
import  {StaticWidgetsData}   from '../../../data/widgets/general/data.js'
import earningSvg from '../general/svgPage/earningSvg.vue'
import productSvg from '../general/svgPage/productSvg.vue'
import messageSvg from '../general/svgPage/messageSvg.vue'
import newuserSvg from '../general/svgPage/newuserSvg.vue'
export default{
    name:'cardsPage',
    data(){
        return{
      menudata: StaticWidgetsData       
     
}
    },
    components:{
        earningSvg,productSvg,messageSvg,newuserSvg
    }
}
</script>
